<script>
	import { store } from "../store.js";
	import { getPosts } from "../getPosts.js";
	import { onMount } from "svelte";

	async function setPagination() {
		let currentPage = $store.options[$$props.id].filtres.page;
		let max_num_pages = $store.options[$$props.id].max_num_pages;
		let offsetAfter = 5;
		let offsetBefore = 5;
		$store.pagination.before = [];
		$store.pagination.after = [];

		for (
			let i = currentPage + 1;
			i < currentPage + offsetAfter && i <= max_num_pages;
			i++
		) {
			$store.pagination.after.push(i);
		}

		for (let i = currentPage - 1; i > currentPage - offsetBefore && i > 1; i--) {
			$store.pagination.before.push(i);
		}
		$store.pagination.before.reverse();
	}

	onMount(async () => {
		setPagination();
	});

	async function turn_page(page_number) {
		$store.options[$$props.id].filtres.page = page_number;
		setPagination();
		let wrapper = document.querySelectorAll(".cg_wrapper")[$$props.id];
		wrapper.scrollIntoView();
		document.activeElement.blur();
		$store.options[$$props.id].loading = true;

		let params = new URLSearchParams(
			$store.options[$$props.id].filtres
		).toString();

		let myPosts = await getPosts(params);
		$store.posts[$$props.id] = myPosts;
		$store.options[$$props.id].found_posts = myPosts.found_posts;
		$store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
		$store.options[$$props.id].loading = false;

		// console.log($store.options[$$props.id].max_num_pages);
		// console.log($store.options[$$props.id].filtres.page - 1);
	}
</script>

<div class="cg_paginate">
	{#if $store.options[$$props.id].filtres.page > 1}
		<button on:click={() => turn_page(1)}>1 </button>
		{#if $store.options[$$props.id].max_num_pages > 4}
			...
		{/if}
	{/if}

	{#each $store.pagination.before as i}
		<button
			class={$store.options[$$props.id].filtres.page === i ? "active" : ""}
			on:click={() => turn_page(i)}
			>{i}
		</button>
	{/each}
	<button class="active">{$store.options[$$props.id].filtres.page} </button>
	{#each $store.pagination.after as i}
		<button
			class={$store.options[$$props.id].filtres.page === i ? "active" : ""}
			on:click={() => turn_page(i)}
			>{i}
		</button>
	{/each}

	{#if $store.options[$$props.id].max_num_pages > 4 && $store.options[$$props.id].max_num_pages !== $store.options[$$props.id].filtres.page}
		...
		<button on:click={() => turn_page($store.options[$$props.id].max_num_pages)}
			>{$store.options[$$props.id].max_num_pages}
		</button>
	{/if}
</div>
